import { PARAGRAPH_TYPE } from './constant.js';

function createParagraph(children = []) {
  return {
    type: PARAGRAPH_TYPE,
    children
  };
}

export { createParagraph };
//# sourceMappingURL=method.js.map
